import React from 'react';
import { Link } from 'react-router';
/** import third-party libraries in the section above, keep the ascending order */

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
/** import mui components in the section above, keep the ascending order */

import { BodyText } from 'widgets-v5/typography';
import Spacer from 'widgets-v5/spacer';
/** import widgets components in the section above, keep the ascending order */

const InfoAlertDealModal = ({ adId }) => {
    const campaignId = adId?.toString().substring(0, 5);

    return (
        <React.Fragment>
            <Grid>
                <Spacer type="small" />
                <Box>
                    <Alert severity="info">
                        The details of the deal maybe edited in the{' '}
                        <Link
                            to={`/campaigns/${campaignId}/setup/ads/${adId}/edit`}
                            style={{ display: 'inline-block' }}
                        >
                            <BodyText type="link">ad setup page</BodyText>
                        </Link>
                        .
                    </Alert>
                </Box>
            </Grid>
        </React.Fragment>
    );
};

export default InfoAlertDealModal;
